<script>
import {
  pageTitleMixin,
  prefetchDataMixin,
} from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import FormError from '@/components/FormError';
import service from './service';

export default {
  pageTitle: 'Отправить сотрудника в отпуск',
  async prefetchData () {
    if (!this.hasPermissions) {
      return;
    }

    this.isFetching = true;

    const workers = await service.getList();

    this.workerOptions = workers.map(({ id, name }) => ({
      value: id,
      text: name,
    }));

    this.isFetching = false;
  },
  mixins: [
    pageTitleMixin,
    prefetchDataMixin,
  ],
  data () {
    return {
      isFetching: false,
      isSaving: false,
      error: '',
      workerOptions: [],
      worker: '',
      dateStart: '',
      dateEnd: '',
    };
  },
  computed: {
    hasPermissions () {
      return (
        this.$store
          .getters['auth/checkPermission'](permissions.WORKER_READ)
        && this.$store
          .getters['auth/checkPermission'](permissions.LOG_WRITE)
      );
    },
  },
  methods: {
    handleDateStartInput (value) {
      this.dateStart = value;
    },
    handleDateEndInput (value) {
      this.dateEnd = value;
    },
    handleWorkerSelect (value) {
      this.worker = value;
    },
    async handleSubmit (e) {
      e.preventDefault();

      if (this.isSaving) {
        return;
      }

      const { worker, dateStart, dateEnd } = this;

      if (!worker || !dateStart || !dateEnd) {
        this.error = 'Заполните все поля';
        return;
      }

      this.error = '';
      this.isSaving = true;

      try {
        await service.setVacation({ worker, dateStart, dateEnd });

        this.handleClose();
      } catch (error) {
        console.log(error);
        this.error = 'Ошибка при отправке в отпуск';
      }

      this.isSaving = false;
    },

    handleClose () {
      this.$emit('close');
      this.$router.push('/workers');
    },
  },
  render () {
    if (!this.hasPermissions) {
      return (
        <u-modal onClose={this.handleClose}>
          <ErrorAccessDenied />
        </u-modal>
      );
    }

    if (this.isFetching) {
      return <u-spinner />;
    }

    const {
      $style,
      worker,
      workerOptions,
      dateStart,
      dateEnd,
      error,
      isSaving,
    } = this;

    return (
      <u-modal onClose={this.handleClose}>
        <u-title
          slot="header"
          level="2"
        >
          Отправить в отпуск
        </u-title>

        <form
          action="#"
          method="post"
          onSubmit={this.handleSubmit}
        >
          <div class="form-field">
            <div class="form-field__label">
              Сотрудник
            </div>
            <u-select
              required
              fullwidth
              id="workerSelect"
              name="worker"
              placeholder="Выберите сотрудника"
              value={worker}
              options={workerOptions}
              onInput={this.handleWorkerSelect}
            />
          </div>

          <div class="form-field">
            <div class="form-field__label">
              Период
            </div>
            <div class={$style.dateRange}>
              с
              <u-datepicker
                class={$style.dateRangeInput}
                required
                id="dateStartInput"
                name="dateStart"
                autocomplete="off"
                placeholder="выберите дату"
                max={dateEnd}
                value={dateStart}
                onInput={this.handleDateStartInput}
              />
              по
              <u-datepicker
                class={$style.dateRangeInput}
                required
                id="dateEndInput"
                name="dateEnd"
                autocomplete="off"
                placeholder="выберите дату"
                min={dateStart}
                value={dateEnd}
                onInput={this.handleDateEndInput}
              />
            </div>
          </div>

          <div class={['form-field', $style.notice]}>
            {/* eslint-disable-next-line */}
            У выбранного сотрудника будут проставлены трудозатраты в будние дни периода в размере 8 часов в проекте «Отпуск»
          </div>

          {Boolean(error) && (
            <FormError>
              {error}
            </FormError>
          )}

          <footer class="form-footer">
            <u-btn
              size="wide"
              type="submit"
            >
              {isSaving
                ? <u-spinner inline />
                : 'Отправить'}
            </u-btn>
          </footer>
        </form>
      </u-modal>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.dateRange {
  align-items: baseline;
  display: flex;

  & :global(.u-input__input) {
    min-width: 120px;
  }

  & :global(.u-datepicker) {
    margin: 0 .5em;

    &:last-child {
      margin-right: 0;
    }
  }
}

.notice {
  color: $color-gray-darker;
  font-size: .825em;
  line-height: 1.25;
  max-width: 400px;
}
</style>
